module.exports = __webpack_public_path__ + "img/video_2.1f8f59ab.jpg";